import { object, string } from 'yup';

export const contactPropertySchema = object({
  key: string(),
  value: string().nullable(),
});
